import './BigNumber.css'

interface Props {
  value: number
  huge?: boolean
}

export function BigNumber(props: Props) {
  return (
    <p className={`BigNumber${props.huge ? ' huge' : ''}`}>
      {props.value}
      {props.huge ? null : '.'}
    </p>
  )
}
